import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent } from '../../common/icon/icon.component';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { NotificationStyle } from '../notification-config';

@Component({
  selector: 'rt-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, SpinnerComponent],
})
export class NotificationIconComponent {
  public readonly notificationStyle = input<NotificationStyle>(undefined!);

  public NotificationStyle = NotificationStyle;
}
